export enum ChecklistResourceType {
  SALE_VEHICLE = 'SALE_VEHICLE',
  SERVICE_VEHICLE = 'SERVICE_VEHICLE',
  BUSINESS_CASE = 'BUSINESS_CASE',
  CUSTOMER = 'CUSTOMER',
  INTEREST = 'INTEREST',
  SERVICE_CASE = 'SERVICE_CASE',
  WAREHOUSE_ARTICLE = 'WAREHOUSE_ARTICLE',
  DIRECT_SALE = 'DIRECT_SALE',
  RECEIVE_NOTE = 'RECEIVE_NOTE',
  RECEIVE_NOTE_CORRECTION = 'RECEIVE_NOTE_CORRECTION',
  SERVICE_ORDER_ISSUE = 'SERVICE_ORDER_ISSUE',
  SERVICE_ORDER_RETURNS = 'SERVICE_ORDER_RETURNS',
  SERVICE_ORDER = 'SERVICE_ORDER',
}
